<div class="offer-header text-center">
  <div class="offer-icon text-[48px] mb-[8px]">🎁</div>
  <h2 class="offer-title font-bold text-site">Offre spéciale disponible !</h2>
</div>
<mat-dialog-content>
  <div class="offer-body bg-base-200 rounded-[12px] p-[16px] mb-[20px]">
    <p class="offer-name text-base">{{ data.promotion.title }}</p>
    @if (data.promotion.payload?.description) {
      <p class="offer-description text-[#666]">
        {{ data.promotion.payload.description }}
      </p>
    }

    <div class=" flex flex-col gap-[10px]">
      <div class="offer-interval flex justify-between items-center rounded-[8px] py-[8px] px-[12px] text-sm">
        <span class="text-site">Total éligible à la promo :</span>
        <span class="interval-value font-bold text-site">{{ data.promoEligibleTotal  | number:'1.2-2' }} €</span>
      </div>

      <div class="offered-categories rounded-[8px] py-[10px] px-[12px]">
        <p class="categories-label text-sm font-semibold text-[#555] ">Produits offerts :</p>
        <ul>
          @for (cat of sortedCategories; track cat) {
            <li class="text-site">
              <strong class="text-site">{{ cat.quantity }}x</strong> {{ cat.category.name }}
              @if (cat.size) {
                <span class="text-site"> - Taille : {{ cat.size.name }}</span>
              }
            </li>
          }
        </ul>
      </div>
    </div>
  </div>

</mat-dialog-content>

<div class="offer-actions flex justify-end gap-[12px] px-4 pb-4">
  <button
    [matButton]="themeConfig.appearance.button.cancel"
    class="w-full" (click)="ignore()">
    Ignorer
  </button>
  <button
    [matButton]="themeConfig.appearance.button.action"
     class=" w-full py-3 flex justify-center" (click)="customize()">
    🎁 En profite
  </button>
</div>
